<template>
  <div class="claw-home">
    <div class="home-header">
      <div class="header-icon" v-if="digitalPersonInfo.logo">
        <img :src="digitalPersonInfo.logo" alt="">
      </div>
      <div class="header-text">
        <div class="home-title-row">
          <div class="home-title" :title="digitalPersonInfo.title">{{ digitalPersonInfo.title }}</div>
          <el-tooltip content="偏好设置" placement="bottom">
            <div v-if="showSupplyChainSettings" class="supply-settings-btn" @click="handleSupplyChainSettings">
              <i class="el-icon-set-up"></i>
            </div>
          </el-tooltip>
        </div>
        <div class="home-subtitle" :title="digitalPersonInfo.subtitle">{{ digitalPersonInfo.subtitle }}</div>
      </div>
    </div>
    <div class="home-cards">
      <div
        v-for="(card, index) in digitalPersonInfo.cards"
        :key="index"
        class="recommend-card"
        @click="handleCardClick(card)"
      >
        <div class="recommend-card-icon">
          <i :class="card.icon"></i>
        </div>
        <div class="recommend-card-content">
          <div class="recommend-card-title" :title="card.title">{{ card.title }}</div>
          <div class="recommend-card-desc" :title="card.desc">{{ card.desc }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { parseAgentTags } from '@/store/modules/cosmoClaw'
import { getSupplyChainAvatar, SUPPLY_CHAIN_INTERNAL_NAME } from '../utils/digitalHumanAvatar'

const CEO_INFO = {
  titleKey: 'workbench.digitalCEOAssistant',
  subtitleKey: 'workbench.digitalCEOAssistantDesc',
  logo: require('@/assets/imgs/workbench/ceo.png'),
  cards: [
    // { titleKey: 'workbench.ceoBusinessSummary', descKey: 'workbench.ceoBusinessSummaryDesc', contentKey: 'workbench.ceoBusinessSummaryContent', icon: 'el-icon-data-line', scenario: 'h1Review' },
    { titleKey: 'workbench.ceoBusinessSummary', descKey: 'workbench.ceoBusinessSummaryDesc', contentKey: 'workbench.ceoBusinessSummaryContent', icon: 'el-icon-data-line', scenario: '' },
    { titleKey: 'workbench.ceoGapPlanning', descKey: 'workbench.ceoGapPlanningDesc', contentKey: 'workbench.ceoGapPlanningContent', icon: 'el-icon-s-marketing', scenario: 'strategyPlanning' }
  ]
}

const CEO_DEMO_INFO = {
  titleKey: 'workbench.digitalCEOAssistant',
  subtitleKey: 'workbench.digitalCEOAssistantDesc',
  logo: require('@/assets/imgs/workbench/ceo.png'),
  cards: [
    { titleKey: 'workbench.financialAnalysis', descKey: 'workbench.financialAnalysisDesc', contentKey: 'workbench.analyzeGrossMargin', icon: 'el-icon-data-line' },
    { titleKey: 'workbench.anomalyRootCause', descKey: 'workbench.anomalyRootCauseDesc', contentKey: 'workbench.pvmcAnalysisContent', icon: 'el-icon-aim' },
    { titleKey: 'workbench.smartSolution', descKey: 'workbench.smartSolutionDesc', contentKey: 'workbench.quadrantAnalysisContent', icon: 'el-icon-top-right' },
    { titleKey: 'workbench.indicatorPrecipitation', descKey: 'workbench.indicatorPrecipitationDesc', contentKey: 'workbench.missingIndicatorContent', icon: 'el-icon-warning-outline' }
  ]
}

const GC_CEO_INFO = {
  titleKey: 'workbench.digitalCEOAssistant',
  subtitleKey: 'workbench.digitalCEOAssistantDesc',
  logo: require('@/assets/imgs/workbench/ceo.png'),
  cards: [
    { titleKey: 'workbench.gcAnalysisTitle', descKey: 'workbench.gcAnalysisDesc', contentKey: 'workbench.gcAnalysisContent', icon: 'el-icon-data-line' },
    { titleKey: 'workbench.gcStrategyTitle', descKey: 'workbench.gcStrategyDesc', contentKey: 'workbench.gcStrategyContent', icon: 'el-icon-s-marketing' }
  ]
}

const LQZ_CEO_INFO = {
  titleKey: 'workbench.digitalCEOAssistant',
  subtitleKey: 'workbench.digitalCEOAssistantDesc',
  logo: require('@/assets/imgs/workbench/ceo.png'),
  cards: [
    { titleKey: 'workbench.lqzAnalysisTitle', descKey: 'workbench.lqzAnalysisDesc', contentKey: 'workbench.lqzAnalysisContent', icon: 'el-icon-data-line' },
    { titleKey: 'workbench.lqzBusinessTitle', descKey: 'workbench.lqzBusinessDesc', contentKey: 'workbench.lqzBusinessContent', icon: 'el-icon-s-marketing' }
  ]
}

const CFO_INFO = {
  titleKey: 'workbench.digitalCFOAssistant',
  subtitleKey: 'workbench.digitalCFOAssistantDesc',
  logo: require('@/assets/imgs/workbench/cfoLogo.png'),
  cards: [
    { titleKey: 'workbench.cfoGrossMarginAnalysis', descKey: 'workbench.cfoGrossMarginAnalysisDesc', contentKey: 'workbench.cfoGrossMarginAnalysisContent', icon: 'el-icon-data-line' },
    { titleKey: 'workbench.cfoFinancialHealth', descKey: 'workbench.cfoFinancialHealthDesc', contentKey: 'workbench.cfoFinancialHealthContent', icon: 'el-icon-s-data' },
    { titleKey: 'workbench.cfoRollingForecast', descKey: 'workbench.cfoRollingForecastDesc', contentKey: 'workbench.cfoRollingForecastContent', icon: 'el-icon-s-marketing' },
    { titleKey: 'workbench.cfoCostStructure', descKey: 'workbench.cfoCostStructureDesc', contentKey: 'workbench.cfoCostStructureContent', icon: 'el-icon-pie-chart' }
  ]
}

const DIRECTOR_INFO = {
  titleKey: 'workbench.digitalFactoryAssistant',
  subtitleKey: 'workbench.digitalFactoryAssistantDesc',
  logo: require('@/assets/imgs/workbench/gongzhang.png'),
  cards: [
    { titleKey: 'workbench.historyProductionReview', descKey: 'workbench.historyProductionReviewDesc', contentKey: 'workbench.historyReviewContent', icon: 'el-icon-monitor' },
    { titleKey: 'workbench.processQualityAnalysis', descKey: 'workbench.processQualityAnalysisDesc', contentKey: 'workbench.qualityReportQuery', icon: 'el-icon-tickets' }
  ]
}

const CSO_INFO = {
  titleKey: 'workbench.digitalSupplyChainAssistant',
  subtitleKey: 'workbench.digitalSupplyChainAssistantDesc',
  logo: require('@/assets/imgs/workbench/csoLogo.png'),
  cards: [
    { titleKey: 'workbench.supplyChainBrief', descKey: 'workbench.supplyChainBriefDesc', contentKey: 'workbench.supplyChainBriefContent', icon: 'el-icon-data-analysis' },
    { titleKey: 'workbench.mcuStockCrisis', descKey: 'workbench.mcuStockCrisisDesc', contentKey: 'workbench.mcuStockCrisisContent', icon: 'el-icon-warning-outline' }
  ]
}

const DIGITAL_PERSON_MAP = {
  cai_wu_shu_zi_ren: CFO_INFO,
  gong_ying_lian_shu_zi_ren: CSO_INFO,
  chang_zhang_shu_zi_ren: DIRECTOR_INFO
}

export default {
  name: 'CosmoClawHome',
  computed: {
    ...mapState('cosmoClaw', ['isCeoDemo', 'isGc', 'isLqz']),
    ...mapGetters(['currentWorkbench']),
    profileAvatar() {
      // 仅供应链数字人使用数字人档案头像，不影响 CEO/财务等其它数字人
      if (this.$store.state.cosmoClaw.currentAgentName !== SUPPLY_CHAIN_INTERNAL_NAME) return ''
      return getSupplyChainAvatar(this.$store.state.user.agentList)
    },
    digitalPersonInfo() {
      const agentName = this.$store.state.cosmoClaw.currentAgentName
      let info = DIGITAL_PERSON_MAP[agentName]
      if (!info && agentName === 'ceo_shu_zi_ren') {
        if (this.isLqz) {
          info = LQZ_CEO_INFO
        } else if (this.isGc) {
          info = GC_CEO_INFO
        } else if (this.isCeoDemo) {
          info = CEO_DEMO_INFO
        } else {
          info = CEO_INFO
        }
      }
      if (!DIGITAL_PERSON_MAP[agentName] && this.currentWorkbench && this.currentWorkbench.name && this.currentWorkbench.name.includes('厂长')) {
        info = DIRECTOR_INFO
      }
      // 兜底：未配置的数字人/智能体（如指标定义智能体等）不崩溃，展示真实名称
      if (!info) {
        const agentList = this.$store.state.user.agentList || []
        // 优先按真实 agentId 精确匹配：同一 internalName 可能对应多个实例
        // （兜底 internalName 相同、仅 displayName 不同的数字人），只按 internalName 查找
        // 会命中列表中排在前面的其它实例，导致标题串号
        const currentAgentId = this.$store.state.cosmoClaw.currentAgentId
        let matched = currentAgentId
          ? agentList.find((a) => String(a.id) === String(currentAgentId))
          : null
        if (!matched) {
          matched = agentList.find((a) => {
            try {
              const { internalName } = parseAgentTags(a.tags, a.name)
              return internalName === agentName
            } catch (e) {
              return false
            }
          })
        }
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.log('[SALE-DRAWER-DEBUG] Home fallback render', {
            agentName,
            currentAgentId: currentAgentId || '',
            matchedId: matched && matched.id,
            matchedDisplayName: matched && (matched.displayName || matched.name),
            title: (matched && (matched.displayName || matched.name)) || agentName || ''
          })
        }
        return {
          title: (matched && (matched.displayName || matched.name)) || agentName || '',
          subtitle: '',
          logo: this.profileAvatar || ((matched && (matched.icon || matched.iconUrl)) || ''),
          cards: []
        }
      }
      return {
        ...info,
        title: this.$t(info.titleKey),
        subtitle: this.$t(info.subtitleKey),
        logo: this.profileAvatar || info.logo,
        cards: info.cards.map(card => ({
          ...card,
          title: this.$t(card.titleKey),
          desc: this.$t(card.descKey),
          content: this.$t(card.contentKey)
        }))
      }
    },
    showSupplyChainSettings() {
      if (this.$store.state.cosmoClaw.currentAgentName !== 'gong_ying_lian_shu_zi_ren') return false
      const userCode = this.$store.state.user.userInfo?.userCode
      if (!userCode) return false
      const isProd = process.env.VUE_APP_ENV === 'prod'
      const allowedCode = isProd ? 'czwl@cosmoplat.cn' : '01506650'
      return userCode === allowedCode
    }
  },
  methods: {
    handleSupplyChainSettings() {
      document.dispatchEvent(new CustomEvent('cosmo-claw-open-preference'))
    },
    async handleCardClick(card) {
      const agentName = this.$store.state.cosmoClaw.currentAgentName
      // CEO演示数字人 / GC/LQZ标签数字人：不触发demo流程，直接发送真实消息
      if (agentName === 'ceo_shu_zi_ren' && (this.isCeoDemo || this.isGc || this.isLqz)) {
        this.$store.dispatch('cosmoClaw/sendMessage', { content: card.content })
        return
      }
      if (agentName === 'cai_wu_shu_zi_ren' && /毛利率|下滑|诊断/.test(card.content || '')) {
        // 使用 storeMockMessage 创建 user 消息（本地 + 持久化到后端）
        this.$store.dispatch('cosmoClaw/storeMockMessage', {
          role: 'user',
          content: card.content
        })
        if (typeof window.triggerCfoScenario === 'function') {
          window.triggerCfoScenario('margin', card.content)
        }
        return
      }
      // CEO数字人新卡片触发demo流程
      if (agentName === 'ceo_shu_zi_ren' && card.scenario) {
        // 使用 storeMockMessage 创建 user 消息（本地 + 持久化到后端）
        await this.$store.dispatch('cosmoClaw/storeMockMessage', {
          role: 'user',
          content: card.content
        })
        // 根据不同场景触发不同的demo流程
        if (card.scenario === 'h1Review') {
          // 分析卡奥斯2026年上半年经营情况，分析1-6月的收入情况、签约情况毛利率和利润情况，总结上半年目标完成情况和对比分析场景
          if (typeof window.triggerCeoH1Summary === 'function') {
            window.triggerCeoH1Summary()
          }
        } else if (card.scenario === 'strategyPlanning') {
          // 千亿市值目标发展规划场景：触发战略规划推演demo流程
          if (typeof window.triggerCeoStrategyPlanningDemo === 'function') {
            window.triggerCeoStrategyPlanningDemo()
          }
        }
        return
      }
      this.$store.dispatch('cosmoClaw/sendMessage', { content: card.content })
    }
  }
}
</script>

<style lang="scss" scoped>
.claw-home {
  padding: 0 8px 28px;
  overflow-y: auto;
  overflow-x: hidden;
}

.home-header {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 42px;
}

.header-icon {
  flex-shrink: 0;
  width: 60px;
  height: 60px;

  img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
  }
}

.header-text {
  display: flex;
  align-items: start;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}

.home-title-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.home-title {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.supply-settings-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  color: #c0c4cc;
  font-size: 16px;
  cursor: pointer;
  transition: color 0.3s ease;
  flex-shrink: 0;

  &:hover {
    color: #4e5969;
  }
}

.home-subtitle {
  font-size: 13px;
  color: #666;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.home-desc {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
  line-height: 1.6;
}

.home-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 14px;
}

.recommend-card {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 12px;
  background: #f8f9fe;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s, transform 0.15s;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);

  &:hover {
    background: #eaf2fd;
    box-shadow: 0 4px 12px rgba(74, 144, 226, 0.12);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  }
}

.recommend-card-icon {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eff1fd;
  border-radius: 10px;
  color: #3370ff;
  font-size: 18px;
}

.recommend-card-content {
  flex: 1;
  min-width: 0;
}

.recommend-card-title {
  font-size: 14px;
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 4px;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recommend-card-desc {
  font-size: 12px;
  color: #999;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
